import getAllPagesInQueue from '../getAllPagesInQueue';

/**
 * @method getAllPagesInQueue
 * @param {Array}pageRangesQueue array of page ranges to print
 * @param {Array}pagesAlreadyPrinted array of page index already printed
 * @param {Array}pages all pages in the book
 * @returns {Number} Percentage of book selected for print
 */
const calculateSelectionPercent = (
  pageRangesQueue,
  pagesAlreadyPrinted = [],
  pages,
) => {
  const totalPagesLength = pages?.length;
  const pageNumbers = [...new Set(getAllPagesInQueue(pageRangesQueue))];

  if (!totalPagesLength || !pageNumbers.length) {
    // book has no pages or no pages is selected
    return 0;
  }

  // Don't count pages already printed toward selection amount
  const newlySelectedPages = pageNumbers.filter(
    (page) => !pagesAlreadyPrinted.includes(page),
  );

  return newlySelectedPages?.length / totalPagesLength;
};

export default calculateSelectionPercent;
